<template>
  <base-simple-modal
    :show-modal="true"
    @close-modal="closeModal"
  >
    <template v-slot:content>
      <div
        class="p-6 mb-1 overflow-y-auto rounded shadow-2xl vld-parent"
        style="width: 560px;"
      >
        <div class="mb-3 title">
          <div class="flex items-center justify-between">
            <h1 class="font-bold ">ファイルアップロード</h1>
            <button @click="closeModal"><close-icon /></button>
          </div>
          <p class="text-sm text-gray-400">
            ファイルフォーマットは「PPTX,PDF」のみに対応しています。
          </p>
        </div>
        <div class="content">
          <file-upload-form 
            :dropped-files="droppedFiles"
            :board-ids="boardIds"
            @before-upload="beforeUpload"
            @after-upload="afterUpload"
          />
        </div>

      </div>
    </template>
  </base-simple-modal>
</template>

<script>
import { useStore } from "vuex";
import { reactive } from "vue";
import BaseSimpleModal from "./BaseSimpleModal.vue";
import FileUploadForm from "../FileUploadeForm.vue"
import CloseIcon from "../../icons/CloseIcon.vue";

export default {
  components: {
    BaseSimpleModal,
    FileUploadForm,
    CloseIcon
  },

  props: {
    droppedFiles: {
      type: Array,
      required: false
    },
    boardIds: {
      type: Array,
      default() { return [] },
      required: false
    }
  },

  emits: [
    'closeModal',
    'openSuccessModal',
    'toggleLoading'
  ],

  setup(_, { emit }) {
    const store = useStore();

    const state = reactive({
      showModal: false,
    });

    store.dispatch('upload/openModal');

    const beforeUpload = () => {
      emit('toggleLoading')
    }

    const afterUpload = () => {
      emit('toggleLoading');
      closeModal();
      emit('openSuccessModal');
    }

    const closeModal = () => {
      store.dispatch('upload/closeModal');
      emit('closeModal')
    }

    return {
      state,
      beforeUpload,
      afterUpload,
      closeModal
    };
  }
};
</script>